module.exports = __webpack_public_path__ + "static/media/blank-asset.3e19fc7b.svg";